import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ChangeFirstLetterCapital } from '../../lib/common';
import { handleSetCsPortalData } from '../../reducersAndActions/actions/appStateActions';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import useSelectedBusiness from '../../hooks/useSelectedBusiness';
import { useAuth } from '../../contexts/auth';
import '../../styles';
import { handlAuthSelectedBusiness } from '../../reducersAndActions/actions/authAction';

export default function BusinessPopup({ handleCloseBusinessPopup, setIsBusinessChange, createTicketFlag }) {
  const [authState, dispatch] = useAuth();
  const { setSelectedBusinessState } = useSelectedBusiness();
  const { type, selectedBusiness, allBusinesses } = authState;
  const selectedBusinessId = selectedBusiness ? selectedBusiness.docid : null;
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const ref = useRef(null);

  useClickAwayListener(ref, () => {
    document.body.style.overflow = 'unset';
    handleCloseBusinessPopup('businessPopup');
  });

  // Move screen-reader/keyboard focus inside the dialog so it cannot land on the page behind it
  useEffect(() => {
    const options = ref.current ? ref.current.querySelectorAll('[role="radio"]') : [];
    const focusTarget = Array.from(options).find((el) => el.getAttribute('aria-checked') === 'true') || options[0];
    if (focusTarget) {
      focusTarget.focus();
    }
  }, []);

  const handleSelectBusiness = (item) => {
    document.body.style.overflow = 'unset';
    if (type === 'business') {
      setIsBusinessChange(true);
    }
    handleSetCsPortalData(dispatch, {
      csportalData: { type, docId: item?.docid || '' },
    });
    handlAuthSelectedBusiness(dispatch, item);
    setSelectedBusinessState(item);

    if (createTicketFlag === '1') {
      if (item.parentid && item.data_city) {
        navigate(
          `/csportal/create_ticket?parentId=${item.parentid}&city=${item.data_city}&key=&vertical=${
            queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''
          }
          &raiseTicketTrackerID=&createTicket=1`,
        );
      }
    }
    handleCloseBusinessPopup('businessPopup');
  };

  return (
    <section className="cs_modal csslbusiness_pop" role="dialog" aria-modal="true" aria-label="Select a business">
      <div className="cs_business_modal_content cs_modal_animation cs_modal_up" ref={ref}>
        <div className="cs_modal_body">
          <div className="pop_slbusiness_header">
            <div className="font15 fw600 popup-heading-div color111 pt-20 pl-20 pr-20">
              Select a business
              <div
                className="modal_close csicon"
                onClick={() => handleCloseBusinessPopup('businessPopup')}
                aria-label="Close Modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
          </div>

          <ul
            className="pop_slbusiness_listgroup no-highlighting mt-10"
            role="radiogroup"
            aria-label="Select a business"
          >
            {allBusinesses &&
              allBusinesses.length &&
              allBusinesses.map((business, idx) => {
                const dataCity = ChangeFirstLetterCapital(business.data_city);
                const areaname = business.areaname !== '' ? `${business.areaname},  ` : '';
                const location = `${areaname} ${dataCity}`;
                const isSelected = selectedBusinessId === business.docid;
                const paidLabel = business?.paidstatus === 1 ? ', Paid' : '';
                const optionLabel = `${business.compname}${paidLabel}, ${location.replace(/\s+/g, ' ').trim()}`;
                const handleActivate = () => handleSelectBusiness(business);
                return (
                  <li className="slbusiness_listgroup_item pl-20 pr-20" key={idx} role="none">
                    {/* The whole option is one accessible radio; everything inside it is decorative
                        so the radio icon cannot produce a separate announcement. */}
                    <div
                      className="slbusiness_tabbox animtabbox"
                      role="radio"
                      aria-checked={isSelected}
                      aria-label={optionLabel}
                      tabIndex={0}
                      onClick={handleActivate}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                          e.preventDefault();
                          handleActivate();
                        }
                      }}
                    >
                      <input
                        id={business.docid}
                        className="slbusiness_tab_radio animradio"
                        type="radio"
                        name="radio"
                        tabIndex={-1}
                        aria-hidden="true"
                        readOnly
                      />
                      <div className="slbusiness_label animlabel" aria-hidden="true">
                        <div className="slbusiness_tabtext animtext">
                          <div className="slbusiness_tabmaintxt font14 fw600 color111">
                            {business.compname}
                            <span className="color339 ml-5">{business?.paidstatus === 1 ? `(Paid)` : ''}</span>
                          </div>
                          <div className="slbusiness_tabsmlltxt font11 fw400 color777 mt-2">{location}</div>
                        </div>
                        <div
                          style={{
                            backgroundImage:
                              isSelected &&
                              `url(https://images.jdmagicbox.com/standard/cs_module/6d6ebd5ad02dce2efa16e29230da047a.jpg)`,
                          }}
                          className="slbusiness_radio_icon animicon"
                        />
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </section>
  );
}

BusinessPopup.propTypes = {
  handleCloseBusinessPopup: PropTypes.func.isRequired,
  setIsBusinessChange: PropTypes.func,
  createTicketFlag: PropTypes.string,
};
